export const UPLOAD_MAX_FILE_SIZE_MB = 10;

export const UPLOAD_SUPPORTED_MIME_TYPES = ["*"];
